export function encodeSlug(value: string): string {
  return encodeURIComponent(value);
}
